//-------
// Is object ?
//-------
module.exports = function (obj) {
  return obj === Object(obj);
};
